import React from "react";
import TourUsersTableRow from "./TourUsersTableRow";

const TourUsersTable = ({ token, tourId, users, role }) => {


  return (
    <>
    <h3 className="sub-heading">{role}</h3>
    <table>
      <thead>
        <tr>
          <th className="left">Name</th>
          <th className="left">Email</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        {
          users.map(user => {
            return (
              <TourUsersTableRow 
              key={user}
              userId={user}
              tourId={tourId}
              token={token}
              />
            )
          })
        }
      </tbody>
    </table>
    </>
  );

};

export default TourUsersTable;